import { prefersReducedMotion } from "../helpers";
//import imagesLoaded from "imagesloaded";
import gsap from "gsap";
import { notification } from "../sections/notification";
import { updateMiniCartItemCount } from "../sections/header";
import { openMinicart } from "../sections/mini-cart";

/** @param {HTMLElement} baseElement */

export function init(baseElement) {
  if (!prefersReducedMotion()) {
    fadeInCardImages(baseElement, ".product-card__image-container");
  }

  // Quick Add Version 2

  // TODO: should it work in PDP related products? (probably not)
  if (window.innerWidth > 768) {
    const overlayTriggerButton = baseElement.querySelector(
      ".button--add-to-bag"
    );
    const overlay = baseElement.querySelector(".quick-add-overlay");
    if (!(overlayTriggerButton instanceof HTMLButtonElement)) return;

    overlayTriggerButton.addEventListener("click", (e) => {
      // Open overlay
      overlay.style.display = "block";
      // const quickAddInner = baseElement.querySelector(".quick-add-inner");

      let selectedVariant = "";
      // Get variants buttons
      const variantLabels = Array.from(
        baseElement.querySelectorAll(".variant-input__label-plp")
      );
      const addToBagButton = baseElement.querySelector(
        ".button--quick-add-to-bag"
      );
      if (variantLabels.length == 1) {
        // Set selected variant
        variantLabels[0].classList.add("checked");

        // make the button active
        addToBagButton.classList.remove("disabled");

        selectedVariant = variantLabels[0].id.replace("variant-", "");
      } else {
        for (let label of variantLabels) {
          label.addEventListener("click", (e) => {
            // Uncheck previously checked
            for (let label of variantLabels) {
              label.classList.remove("checked");
            }
            // Check current
            label.classList.add("checked");

            // make the button active
            addToBagButton.classList.remove("disabled");

            selectedVariant = label.nextElementSibling.value;
          });
        }
      }
      addToBagButton.addEventListener("click", (e) => {
        e.preventDefault();

        if (selectedVariant) {
          addItemToCart(selectedVariant);
        }
      });
    });

    const closeButton = baseElement.querySelector(".quick-add--close");
    if (closeButton instanceof HTMLElement) {
      closeButton.addEventListener("click", () => {
        overlay.style.display = "none";
      });
    }
  }
}

export function fadeInCardImages(baseElement, selectorString) {
  const imagesContainer = baseElement.querySelector(selectorString);
  if (!imagesContainer) return;
  const totalImages = imagesContainer.querySelectorAll("img");
  if (!totalImages.length) return;

  let img = totalImages[0];

  if (!img.complete) {
    img.style.opacity = "0";
    img.onload = function() {
      gsap.to(img, {
        opacity: 1,
        onComplete: function() {
          img.style.color = "black"; // alt text
        },
      });
    };
  }
}

/** @param {HTMLElement} baseElement */
/* function setupLoadingAnimation(baseElement) {
  const imageContainer = baseElement.querySelector(
    ".product-card__image-container"
  );
  if (!(imageContainer instanceof HTMLElement)) return;

  const mainImage = imageContainer.querySelector("img:first-of-type");

  if (!(mainImage instanceof HTMLElement)) return;

  mainImage.style.opacity = "0";
  mainImage.style.transition = "opacity 0.3s";

  imagesLoaded(mainImage, ({ images }) => {
    console.log(images);
    for (const image of images) {
      if (image.isLoaded) {
        const { img } = image;
        img.style.opacity = "1.0";
      }
    }
  });
} */

/**
 * @param {{ preventDefault: () => void; }} e
 */
async function addItemToCart(variantId) {
  let data;
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }),
    });
    data = await response.json();
  } catch (e) {
    console.error("Error", e.message);
  }
  // TODO:
  /**
   * https://dmitripavlutin.com/javascript-fetch-async-await/
   * response.ok property lets you separate good from bad HTTP response statuses.
   * if the response has status 200-299 response.ok returns 'true'
   * if there's a bad HTTP status (outside of the range 200-299) response.ok returns 'false'
   * so you can throw an error manually
   *
   * Then: fetch() rejects only if a request cannot be made or a response cannot be retrieved
   * fetch() will not return error for 404
   * */
  if (typeof data !== "object") return;

  if ("items" in data) {
    // Success!
    if (window.innerWidth > 640) {
      openMinicart();
    } else {
      notification().show("success", "Added to bag");
    }
    updateMiniCartItemCount();
  } else if ("description" in data) {
    // Error!
    console.error(
      typeof data.description === "string"
        ? data.description
        : "Something went wrong"
    );
    notification().show(
      "error",
      typeof data.description === "string"
        ? data.description
        : "Something went wrong"
    );
  }
}
